<template>
  <div class="trend-card">
    <a :href="result.detailPage" class="trend-card__header">
      <DefImg :result="result.picture" />
    </a>
    <a :href="result.detailPage" class="trend-card__footer">
      <span class="trend-card__description">
        <span class="trend-card__labels">
          <span
            v-for="label in result.labels"
            class="trend-card__label"
            :style="`background-color: ${label.color}`"
          >
            {{ label.name }}
          </span>
        </span>
        <span class="trend-card__created">
          {{ result.date }}
        </span>
      </span>
      <span class="trend-card__name">{{ result.name }}</span>
    </a>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'TrendCard',
  components: { DefImg },
  props: ['result', 'messages'],
};
</script>

<style lang="scss" scoped>
.trend-card {
  display: flex;
  flex-direction: column;
  position: relative;
  transition: 0.2s linear box-shadow;
  margin-bottom: 6px;
  &:hover {
    box-shadow: 0 4px 8px 0 rgba(16, 24, 40, 0.12);
    :deep(.def-img) {
      transform: scale(1.1);
    }
  }
  &__header {
    overflow: hidden;
  }
  &__description {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    line-height: 125%;
  }
  &__label {
    padding: 2px 8px 3px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }
  &__created {
    color: var(--color-dark-grey);
    font-size: 14px;
    font-weight: 500;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 16px;
  }
  &__name {
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    transition: 0.2s linear color;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }
  :deep(.def-img) {
    transform-origin: center;
    transition: 0.2s linear transform;
  }
}
</style>
